module.exports = __webpack_public_path__ + "img/wf-indexes.487b58b0.svg";